<template>
  <div>
    <el-table
      :data="
        lists.filter(
          (data) =>
            !search || data.key_value.toLowerCase().includes(search.toLowerCase())
        )
      "
      style="width: 100%"
    >
      <el-table-column label="key_id" prop="key_id"> </el-table-column>
      <el-table-column label="key_value"  prop="key_value">
      </el-table-column>
     
    
      <el-table-column align="right">
        <template slot="header" slot-scope="scope">
          <el-input
            v-model="search"
            size="mini"
            placeholder="输入关键字搜索?"
          />
        </template>
		
	  
	  </el-table-column>
    </el-table>




	
	
	
  </div>
</template>

<script>
export default {
  data() {
    return {
      type_id: 0, //栏目id
      options: [
        {
          value: 0,
          label: "待设置",
        },
        {
          value: 1,
          label: "正常",
        },
        {
          value: 2,
          label: "异常",
        },
        {
          value: 3,
          label: "冻结",
        },
      ],

      Logistics: [
        {
          value: 0,
          label: "未设置",
        },
        {
          value: 1,
          label: "收藏",
        },
        {
          value: 2,
          label: "待付款",
        },
        {
          value: 3,
          label: "已付款",
        },
        {
          value: 4,
          label: "待发货",
        },
        {
          value: 5,
          label: "已发货",
        },
        {
          value: 6,
          label: "运输中",
        },
        {
          value: 7,
          label: "已签收",
        },
      ],
      ruleForm: {
        id: 0,
        state: 0, //数据状态
        username: "", //用户姓名
        telephone: "", //用户手机
        address: "", //用户地址

        key_id: "", //标题
        key_value: 0, //市场价
  
      },
      rules: {},
      dialogVisible: false,
      lists: [{}],
      search: "",
      count: 0,
    };
  },
  methods: {
    handleClose(done) {
      //this.$refs[formName].resetFields();
      this.dialogVisible = false;
      // this.$confirm('确认关闭？')
      // 	.then(_ => {
      // 		done();
      // 	})
      // 	.catch(_ => {});
    },
    handleEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          console.log("error submit!!");
          return false;
        }
      });
      //传值
      let data = new FormData();
      //data.append('id', this.ruleForm.id)
      // data.append("state", this.ruleForm.state);
      // data.append("title", this.ruleForm.title);
      // data.append("price_a", this.ruleForm.price_a);
      // data.append("price_b", this.ruleForm.price_b);
      // data.append("total", this.ruleForm.total);
      // data.append("surplus", this.ruleForm.surplus);
      this.$admin
        .postAPI(
          `data/cache/` + this.ruleForm.id + `?type_id=` + this.type_id,
          data
        )
        .then((res) => {
          let data = res.data;
          if (data.code == 200) {
            this.$Message.success("操作成功");
          }
          console.log(data);
        });
      //关闭弹窗
      this.dialogVisible = false;
    },
    //查询
    handleSel(index, row) {
      //打开弹窗
      this.dialogVisible = true;
      //赋值
      //this.ruleForm.id = row.id;
     // this.ruleForm.key_id = row.key_id;
	 // this.ruleForm.key_value = row.key_value;

      console.log(row);
      console.log(index);
    },
    //删除
    handleDelete(index, row) {
      console.log(index, row);
    },
    //加载数据列表类
    getList(page) {
      this.$admin
        .getAPI(`data/cache/?type_id=` + this.type_id + `&page=` + page, {})
        .then((res) => {
          let data = res.data;
		  if(data.data!=null){
			   this.lists = data.data;
		  }
          console.log(data);
        });
    },
    //分页加载
    handleSizeChange(e) {
      this.getList(e);
    },
    //状态转换
    dateState(row, column) {
      const data = row[column.property];
      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].value == data) {
          return this.options[i].label;
        }
      }
      return "未知状态";
    },
    //订单转换
    dateLogistics(row, column) {
      const data = row[column.property];
      for (var i = 0; i < this.Logistics.length; i++) {
        if (this.Logistics[i].value == data) {
          return this.Logistics[i].label;
        }
      }
      return "未知状态";
    },
    //时间格式转换
    dateForma(row, column) {
      const timestamp = row[column.property];
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
  mounted() {
    //默认加载
    if (this.$route.query.type_id != undefined) {
      this.type_id = this.$route.query.type_id;
    }
    this.getList(0);
  },
};
</script>

<style>
.row .col-md-6 {
  padding-bottom: 25px;
}

.w-100 {
  padding-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/admin/body/cache.vue